// Quick Lease Generation Page
import { useState, useEffect } from "react";
import { Grid, Card, Box, Typography } from "@mui/material";
import { Handshake } from "@mui/icons-material";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";
import OneClickLease from "components/OneClickLease";
import { propertyService, tenantService, leaseService } from "services/firestoreService";
import { useAuth } from "contexts/AuthContext";

function QuickLease() {
  const { user } = useAuth();
  const [properties, setProperties] = useState([]);
  const [tenants, setTenants] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (user?.uid) {
      fetchData();
    }
  }, [user]);

  const fetchData = async () => {
    try {
      const [propertiesData, tenantsData] = await Promise.all([
        propertyService.getAll(user.uid),
        tenantService.getAll(user.uid),
      ]);
      setProperties(propertiesData);
      setTenants(tenantsData);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <ArgonBox py={3}>
        {/* Header */}
        <ArgonBox mb={3} textAlign="center">
          <Box display="flex" justifyContent="center" alignItems="center" mb={2}>
            <Handshake sx={{ fontSize: 48, color: "primary.main", mr: 2 }} />
            <ArgonTypography variant="h3" fontWeight="bold">
              Quick Lease Generator
            </ArgonTypography>
          </Box>
          <ArgonTypography variant="body1" color="text">
            Create a complete lease agreement in just 3 clicks!
          </ArgonTypography>
        </ArgonBox>

        {/* Main Content */}
        <Grid container spacing={3} justifyContent="center">
          <Grid item xs={12} md={8} lg={6}>
            <OneClickLease properties={properties} tenants={tenants} />
          </Grid>
        </Grid>

        {/* Features */}
        <Grid container spacing={3} sx={{ mt: 4 }}>
          <Grid item xs={12} md={4}>
            <Card sx={{ p: 3, textAlign: "center", height: "100%" }}>
              <Typography variant="h1" color="primary" sx={{ fontSize: 48, mb: 1 }}>
                1
              </Typography>
              <Typography variant="h6" gutterBottom>
                Select Property
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Choose from your available properties
              </Typography>
            </Card>
          </Grid>
          
          <Grid item xs={12} md={4}>
            <Card sx={{ p: 3, textAlign: "center", height: "100%" }}>
              <Typography variant="h1" color="primary" sx={{ fontSize: 48, mb: 1 }}>
                2
              </Typography>
              <Typography variant="h6" gutterBottom>
                Select Tenant
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Pick from approved applicants
              </Typography>
            </Card>
          </Grid>
          
          <Grid item xs={12} md={4}>
            <Card sx={{ p: 3, textAlign: "center", height: "100%" }}>
              <Typography variant="h1" color="primary" sx={{ fontSize: 48, mb: 1 }}>
                3
              </Typography>
              <Typography variant="h6" gutterBottom>
                Generate & Send
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Lease ready for signatures instantly
              </Typography>
            </Card>
          </Grid>
        </Grid>
      </ArgonBox>
      <Footer />
    </DashboardLayout>
  );
}

export default QuickLease;